import React from "react";
// Routing
import { Link } from "react-router-dom";

// Styling
import styled from "styled-components";

import { motion } from "framer-motion";

// Importing Images
import natours1 from "../images/Natours/img1.png";
import natours2 from "../images/Natours/img2.png";
import natours3 from "../images/Natours/img3.png";
import natours4 from "../images/Natours/img4.png";
import natours5 from "../images/Natours/img5.png";
import natours6 from "../images/Natours/img6.png";
import natours7 from "../images/Natours/img7.png";

// Importing components
import {
  ImgDesc,
  ButtonWrapper,
  Hide,
  ProjectContainer,
} from "../components/ProjectInfoGraphinTunes";

// Animations, Scroll and Icons
import { pageAnimation, Fade, imageAnimation, FadeLine } from "./Animation";
import { ScrollToTop } from "./ScrollToTop";
import { IoCaretBackCircleOutline } from "react-icons/io5";
import { IconContext } from "react-icons";

const ProjectInfoNatours = () => {
  return (
    <ProjectContainer variants={pageAnimation} initial="hidden" animate="show">
      <IconContext.Provider
        value={{
          color: "white",
          size: "70px",
          style: { marginLeft: "3rem" },
        }}
      >
        <Link to="/">
          <Logo>
            <motion.h2 variants={Fade}>Chirag Rao</motion.h2>
            <motion.div variants={Fade}>
              <IoCaretBackCircleOutline className="back" />
            </motion.div>
          </Logo>
        </Link>
      </IconContext.Provider>
      <div className="header">
        <motion.h1 variants={FadeLine} style={{ fontSize: "4rem" }}>
          Natours
        </motion.h1>
        <motion.h3
          variants={Fade}
          style={{ textAlign: "center", width: "80%" }}
        >
          A Full MERN Stack Web Application with Custom Back-end API and
          Payments, along with a fresh and intuitive UI.
        </motion.h3>
        <Hide>
          <motion.img
            variants={imageAnimation}
            src={natours1}
            style={{ margin: "1rem 0rem" }}
            alt="gtimage"
          />
        </Hide>
        <Hide>
          <motion.img
            variants={imageAnimation}
            src={natours2}
            style={{
              margin: "1rem 0rem",
            }}
            alt="gtimage"
          />
        </Hide>
      </div>
      <div className="content">
        <div className="top">
          <div className="text">
            <motion.h1 variants={FadeLine}>Introduction</motion.h1>
            <motion.p variants={Fade}>
              Natours is a full-stack CRUD MERN web application that allows
              users to view and book tours efficiently. It has a custom back-end
              and its own API with sorting, filtering and pagination. It also
              has a payment system using Stripe and uses a custom authentication
              system using JWT. It has multiple routes, an admin route and
              pages, and a beautiful UI. I have also integrated MapBox for
              displaying the location of tours. It follows the MVC architecture.
              There's also a feature which sends emails to welcome users, reset
              passwords and more.
              <br />
              <br />
              <b>
                Web Application -{" "}
                <a
                  style={{ color: "#23d997" }}
                  href="https://natoursprod.herokuapp.com/"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  https://natoursprod.herokuapp.com/
                </a>
              </b>
            </motion.p>
          </div>
          <div className="imageflex">
            <Hide>
              <motion.img variants={imageAnimation} src={natours4} alt="" />
              <ImgDesc>Custom Payments System using Stripe</ImgDesc>
            </Hide>
            <div className="textinner">
              <motion.h3 variants={Fade}>
                This web app's rich tech stack
              </motion.h3>
              <motion.p variants={Fade}>
                <b style={{ color: "#23d997" }}>1.</b> NodeJS - For building the
                core application
                <br />
                <b style={{ color: "#23d997" }}>2. </b> MongoDB Atlas - Cloud
                No-SQL database
                <br />
                <b style={{ color: "#23d997" }}>3. </b> Express -For easy
                implementation of routes
                <br />
                <b style={{ color: "#23d997" }}>4. </b> JSON Web Tokens - For
                auth
                <br />
                <b style={{ color: "#23d997" }}>5. </b> Node Mailer, MailTrap -
                For sending emails
                <br />
                <b style={{ color: "#23d997" }}>6. </b> Pug templating - For UI
                <br />
                <b style={{ color: "#23d997" }}>7. </b> Stripe - For payments
                <br />
                <b style={{ color: "#23d997" }}>8. </b> MapBox - For displaying
                the map.
                <br />
                <b style={{ color: "#23d997" }}>9. </b> Parcel - For bundling
                the javascript files
                <br />
              </motion.p>
            </div>
          </div>
        </div>
        <div className="imageflex">
          <div className="textinner">
            <motion.h3 variants={Fade}>
              More details to access repo and read documentation?
            </motion.h3>
            <motion.p variants={Fade}>
              Check out my very well documented open-source repository of this
              project on Github! The README file of my repo documents the
              Tech-Stack, Usage instructions, Requirements, API features and
              more!
            </motion.p>
          </div>
          <Hide>
            <motion.img
              variants={imageAnimation}
              src={natours6}
              alt="tourdetails"
            />
            <ImgDesc>Custom Tour Details</ImgDesc>
          </Hide>
        </div>
        <ButtonWrapper>
          <motion.button variants={Fade}>
            <a
              style={{ textDecoration: "none", color: "white" }}
              href="https://natoursprod.herokuapp.com/"
              rel="noopener noreferrer"
              target="_blank"
            >
              Visit the Website!
            </a>
          </motion.button>
          <motion.button variants={Fade}>
            <a
              style={{ textDecoration: "none", color: "white" }}
              href="https://github.com/SpaceFace02/Natours-API"
              rel="noopener noreferrer"
              target="_blank"
            >
              View the Github Repo
            </a>
          </motion.button>
        </ButtonWrapper>
        <div className="gallery">
          <motion.h1 variants={FadeLine}>Gallery</motion.h1>
          <Hide>
            <motion.img
              variants={imageAnimation}
              src={natours5}
              alt="Me page"
            />
          </Hide>
          <Hide>
            <motion.img
              variants={imageAnimation}
              src={natours7}
              alt="Password Changing functionality"
            />
          </Hide>
          <Hide>
            <motion.img
              variants={imageAnimation}
              src={natours3}
              alt="Tour Hero Page"
            />
          </Hide>
        </div>
      </div>
      <ScrollToTop />
    </ProjectContainer>
  );
};

export const Logo = styled(motion.div)`
  position: absolute;
  top: 10px;
  left: 10px;
  font-family: "Lobster";
  font-size: "1rem";
  float: right;
  display: flex;
  align-items: flex-end;
  padding: 0rem 1rem;
  margin: 2rem 0rem;
  .back {
    display: none;
  }
  @media screen and (max-width: 520px) {
    h2 {
      display: none;
    }
    .back {
      display: block;
    }
  }
`;

export default ProjectInfoNatours;
